var app = angular.module("leonardo");

var StopInstancesDialog = function($scope, WorkFlowInstanceService, FormErrorsService) {
  $scope.filters = $scope.ngDialogData.filters;
  
  $scope.submit = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    WorkFlowInstanceService.stopInstances($scope.filters).then(function() {
      $scope.confirm();
    }, function (error) {
      $scope.closeThisDialog();
    });
  };

};

app.controller('StopInstancesDialog', ['$scope', 'WorkFlowInstanceService', 'FormErrorsService', StopInstancesDialog]);
    